/* https://shopify.dev/docs/storefronts/themes/trust-security/captcha */
(() => {
  'use strict';
  if (!window.PC || PC.local || PC.preview) return;
  function wireForms() {
    document.querySelectorAll('form[data-pc-contact="true"], form[data-newsletter]').forEach(form => {
      if (form.dataset.pcSecureForm || form.method.toLowerCase() !== 'post') return;
      const type = form.querySelector('input[name="form_type"]')?.value;
      if (!['contact', 'customer'].includes(type)) return;
      const submit = form.querySelector('[type="submit"]');
      if (!submit) return;
      const hasServerSuccess = !!form.querySelector('[data-contact-server-success], [data-pc-server-feedback][role="status"]');
      form.dataset.pcSecureForm = 'loading';
      const status = document.createElement('p');
      status.className = 'pc-secure-form-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.hidden = hasServerSuccess;
      status.style.cssText = 'font-size:0.9rem;line-height:1.5;margin:0.75rem 0 0;';
      form.append(status);
      let ready = false;
      let pending = false;
      let timer;
      const originallyDisabled = submit.disabled;
      function markReady() {
        clearTimeout(timer);
        ready = true;
        form.dataset.pcSecureForm = 'ready';
        submit.disabled = originallyDisabled;
        status.textContent = '';
      }
      function unavailable() {
        if (ready) return;
        form.dataset.pcSecureForm = 'unavailable';
        status.hidden = false;
        status.textContent = 'The secure form could not load. Please refresh this page, or use the email link to contact us.';
        submit.disabled = true;
      }
      // Do not send automatically from the readiness callback. One user click
      // after readiness still follows all native validation and CAPTCHA checks.
      const protect = window.Shopify?.captcha?.protect;
      if (typeof protect === 'function') {
        submit.disabled = true;
        status.textContent = 'Preparing secure form…';
        timer = setTimeout(unavailable, 15000);
        try { protect(form, markReady); } catch { unavailable(); }
      } else {
        // Stores without the CAPTCHA feature keep the native form behavior.
        markReady();
      }
      form.addEventListener('submit', event => {
        if (!ready || pending) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
          return;
        }
        pending = true;
        status.hidden = false;
        submit.disabled = true;
        form.dataset.pcSecureForm = 'submitting';
        form.setAttribute('aria-busy', 'true');
        status.textContent = 'Submitting securely… Complete the verification if it appears.';
        clearTimeout(timer);
        timer = setTimeout(() => {
          form.removeAttribute('aria-busy');
          form.dataset.pcSecureForm = 'unconfirmed';
          status.textContent = 'We could not confirm this submission. Please use the email link to contact us before trying again.';
          // Keep this attempt from being sent twice. Reloading or starting a
          // new visit is an explicit action; there is no automatic retry.
        }, 20000);
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireForms, { once: true });
  else wireForms();
})();
